import { toast } from "react-toastify";
import React from "react";
import { getSupportLink } from "../../../Helpers";

export function DigitSupportLink({ higherEdCourse }: { higherEdCourse?: boolean } = {}) {
  return (
    <a
      href={getSupportLink(higherEdCourse)}
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "inherit", textDecoration: "underline" }}>
      Digit Support
    </a>
  );
}

export const TechnicalIssuesMessage = () => (
  <span>
    Sorry, we are having technical issues. Please try again later or contact{" "}
    <DigitSupportLink /> for immediate assistance.
  </span>
);

const commonToastStyle = {
  borderRadius: "16px",
  boxShadow: "none",
};

const icon = "fa-regular fa-circle-info";
const consistentSize = { fontSize: "16px" };

export const SuccessToast = (message: string | React.ReactNode) => {
  toast.success(<div style={consistentSize}>{message}</div>, {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
    closeButton: false,
    icon: (
      <>
        <style>{`.Toastify__toast-icon { margin-inline-end: 8px !important; width: 16px !important}`}</style>
        <i className={icon} style={consistentSize}></i>
      </>
    ),
    style: {
      color: "#fff",
      backgroundColor: "#2E7D32",
      ...commonToastStyle,
    },
  });
};

export const ErrorToast = (message: string | React.ReactNode) => {
  toast.error(<div style={consistentSize}>{message}</div>, {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    closeButton: true,
    icon: (
      <>
        <style>{`.Toastify__toast-icon { margin-inline-end: 8px !important; width: 16px !important}`}</style>
        <i className={icon} style={consistentSize}></i>
      </>
    ),
    style: {
      color: "#fff",
      backgroundColor: "#C62828",
      ...commonToastStyle,
    },
  });
};

export const WarningToast = (message: string | React.ReactNode) => {
  toast.warn(<div style={consistentSize}>{message}</div>, {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: 5000,
    hideProgressBar: true,
    closeButton: false,
    icon: (
      <>
        <style>{`.Toastify__toast-icon { margin-inline-end: 8px !important; width: 16px !important}`}</style>
        <i className={icon} style={consistentSize}></i>
      </>
    ),
    style: {
      color: "#fff",
      backgroundColor: "#FFA000",
      ...commonToastStyle,
    },
  });
};

export const InfoToast = (
  message: string | React.ReactNode,
  opt?: { autoClose?: number | false; closeOnClick?: boolean; closeButton?: boolean }
) => {
  toast.info(<div style={consistentSize}>{message}</div>, {
    position: toast.POSITION.BOTTOM_CENTER,
    autoClose: opt?.autoClose ?? 5000,
    hideProgressBar: true,
    closeOnClick: opt?.closeOnClick ?? true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    closeButton: opt?.closeButton ?? false,
    icon: (
      <>
        <style>{`.Toastify__toast-icon { margin-inline-end: 8px !important; width: 16px !important}`}</style>
        <i className={icon} style={consistentSize}></i>
      </>
    ),
    style: {
      color: "#474747",
      backgroundColor: "#E2F7FE",
      border: "2px solid #D0D0D0",
      ...commonToastStyle,
    },
  });
};
